import { PermissionComponent } from "../../components";

export default function RoleListPage() {
  return <PermissionComponent.RolesPage.RoleList />;
}
